import { sentenceCase } from 'change-case';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import Label from '../../../components/label';
import { fDate } from '../../../utils/formatTime';
import { Accept, CustodianAccept, CustodianDecline, Decline } from '../../../packages/fixedassets/components';
import { fNumber } from '../../../utils/formatNumber';
import { getProfile } from '../../../shared/auth/authService';

// ----------------------------------------------------------------------

export default function AssetTransfersTableRow({ selected, record, handleSelectClick, onTransferUpdate }) {
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [open, setOpen] = useState(false);
  const [openCustodian, setOpenCustodian] = useState(false);
  const [openDecline, setOpenDecline] = useState(false);
  const [openDeclineCustodian, setOpenDeclineCustodian] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const branchRoles = ['MANAGER', 'BRANCH_MANAGER'];
  const isManager = branchRoles.includes(user?.role);

  const handleModalClose = (setter) => () => {
    setter(false);
    if (onTransferUpdate) onTransferUpdate();
  };

  const handleClose = handleModalClose(setOpen);
  const handleCloseAcceptCustodian = handleModalClose(setOpenCustodian);
  const handleCloseDecline = handleModalClose(setOpenDecline);
  const handleCloseDeclineCustodian = handleModalClose(setOpenDeclineCustodian);

  useEffect(() => {
    const profile = getProfile();
    if (profile) {
      setUser(profile);
    }
  }, []);

  return (
    <>
      {open && <Accept open={open} handleClose={handleClose} transferId={selectedRow?.id} />}
      {openDecline && <Decline open={openDecline} handleClose={handleCloseDecline} transferId={selectedRow?.id} />}
      {openCustodian && (
        <CustodianAccept open={openCustodian} handleClose={handleCloseAcceptCustodian} transferId={selectedRow?.id} />
      )}
      {openDeclineCustodian && (
        <CustodianDecline
          open={openDeclineCustodian}
          handleClose={handleCloseDeclineCustodian}
          transferId={selectedRow?.id}
        />
      )}
      <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox disableRipple checked={selected} onChange={handleSelectClick} />
        </TableCell>

        <TableCell align="left">{fDate(record?.transfered_on)}</TableCell>
        <TableCell align="left">{record?.department?.name}</TableCell>
        <TableCell align="left">{record?.checkedout_by?.user?.display_name}</TableCell>
        <TableCell align="left">{record?.custodian_name}</TableCell>
        <TableCell align="left">{fNumber(record?.total_records)}</TableCell>
        <TableCell align="left">
          <Label color={(record?.admin_approved && 'success') || 'error'}>
            {(record?.admin_approved && 'Yes') || 'No'}
          </Label>
        </TableCell>
        <TableCell align="left">
          <Label color={(record?.custodian_accepted && 'success') || 'error'}>
            {(record?.custodian_accepted && 'Yes') || 'No'}
          </Label>
        </TableCell>
        <TableCell align="left">
          <Label
            color={
              (record?.status === 'PENDING' && 'warning') || (record?.status === 'REJECTED' && 'error') || 'success'
            }
          >
            {record?.status ? sentenceCase(record.status) : '—'}
          </Label>
        </TableCell>
        <TableCell>
          <Stack spacing={2} direction="row">
            {user?.role === 'ADMIN' && record?.status === 'PENDING' && (
              <>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setSelectedRow(record);
                    setOpen(true);
                  }}
                >
                  Approve
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    setSelectedRow(record);
                    setOpenDecline(true);
                  }}
                >
                  Reject
                </Button>
              </>
            )}
            {isManager && record?.custodian_status === 'PENDING' && record?.admin_approved && (
              <>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setSelectedRow(record);
                    setOpenCustodian(true);
                  }}
                >
                  Accept
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    setSelectedRow(record);
                    setOpenDeclineCustodian(true);
                  }}
                >
                  Reject
                </Button>
              </>
            )}
            <Button size="small" variant="contained" onClick={() => navigate(`/dashboard/transfers/${record?.id}`)}>
              View Assets
            </Button>
          </Stack>
        </TableCell>
      </TableRow>
    </>
  );
}

AssetTransfersTableRow.propTypes = {
  record: PropTypes.object,
  handleSelectClick: PropTypes.func,
  selected: PropTypes.bool,
  onTransferUpdate: PropTypes.func,
};
